import { BottomNav } from "../components/BottomNav";
import { BrandHeader } from "../components/BrandHeader";
import { Icon } from "../components/Icon";
import { StatusLabel } from "../components/StatusLabel";
import type { RouteView } from "../hooks/useHashRoute";
import type { UiBriefing } from "../types";

export function CompareView({ briefing, onStory, onNavigate, onSettings, onBrandTap }: { briefing: UiBriefing; onStory: (id: string) => void; onNavigate: (view: RouteView) => void; onSettings: () => void; onBrandTap: () => void }) {
  const stories = [...briefing.stories].sort((left, right) => Number(Boolean(right.contrast)) - Number(Boolean(left.contrast)) || right.sourceCount - left.sourceCount);
  return (
    <>
      <BrandHeader onSettings={onSettings} onBrandTap={onBrandTap} />
      <main className="screen screen--with-nav utility-screen" id="main-content">
        <h1>Compare coverage</h1>
        <p className="page-intro">Same-event reporting matched across publications, ranked by measurable differences in language, emphasis, and sourcing. No universal bias score and no forced left/right pairing.</p>
        <div className="comparison-list">
          {stories.map((story) => (
            <button type="button" key={story.id} onClick={() => onStory(story.id)}>
              <div><span className="small-category">{story.category}</span><h2>{story.headline}</h2><StatusLabel status={story.status} /></div>
              <div className="comparison-list__meta"><span>{story.coverage.length} coverage profiles</span><span>{story.contrast ? `${story.contrast.publisherNameA} ↔ ${story.contrast.publisherNameB}` : "Single-source coverage"}</span></div>
              <Icon name="chevron" />
            </button>
          ))}
        </div>
      </main>
      <BottomNav selected="compare" onNavigate={onNavigate} />
    </>
  );
}
